import { Create } from "react-admin"
import FormInput from "./FormInput"
import { useSearchParams } from 'react-router-dom';


const NumberRangeCreate = () => {
  const [searchParams] = useSearchParams()
  const name = searchParams.get("name")

  return (
    <Create redirect="list"  >
      <FormInput name={name?.toString()} />
    </Create>
  )
}

export default NumberRangeCreate